import {TouchableOpacity, StyleSheet, Text} from "react-native";
import {ButtonProps} from "@/components/form/ButtonProps";
import {useCurrentTheme} from "@/theming/useCurrentTheme";
import {ThemeType} from "@/theming/baseTheme";

interface Props extends ButtonProps {
    color?: 'primary' | 'secondary' | 'error';
    size?: 'small' | 'medium' | 'large';
    underline?: boolean;
}

export const TextButton = ({
                               onPress,
                               title,
                               disabled = false,
                               style,
                               textStyle,
                               color = 'primary',
                               size = 'medium',
                               underline = false,
                               ...props
                           }: Props) => {
    const {theme} = useCurrentTheme();
    const styles = createStyles(theme);

    const getTextColor = () => {
        switch (color) {
            case 'secondary':
                return theme.colors.secondary;
            case 'error':
                return theme.colors.error;
            default:
                return theme.colors.primary;
        }
    };

    const getFontSize = () => {
        switch (size) {
            case 'small':
                return theme.fontSize.xs;
            case 'large':
                return theme.fontSize.lg;
            default:
                return theme.fontSize.sm;
        }
    };

    return (
        <TouchableOpacity
            style={[styles.button, disabled && styles.buttonDisabled, style]}
            onPress={onPress}
            disabled={disabled}
            {...props}
        >
            <Text style={[
                styles.buttonText,
                {
                    color: getTextColor(),
                    fontSize: getFontSize(),
                    textDecorationLine: underline ? 'underline' : 'none'
                },
                textStyle
            ]}>
                {title}
            </Text>
        </TouchableOpacity>
    );
};

const createStyles = (theme: ThemeType) => StyleSheet.create({
    button: {
        alignItems: 'center',
        padding: theme.spacing.sm,
    },
    buttonDisabled: {
        opacity: 0.5,
    },
    buttonText: {
        fontWeight: '600',
    },
});
